export default {
      id: "heart-usage",
      viewBox: "0 0 78.1 70",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#heart",
      toString: function () {
        return this.url;
      }
    }